// extracted by mini-css-extract-plugin
export var actionButton = "_hz-0";
export var actionMenuContainer = "_hz-i";
export var bubble = "_hz-2";
export var bubbleActionMenu = "_hz-j";
export var bubbleContext = "_hz-6";
export var bubbleItems = "_hz-7";
export var customer = "_hz-3";
export var divider = "_hz-8";
export var fileList = "_hz-9";
export var hiddenComment = "_hz-o";
export var infoAbove = "_hz-a";
export var internal = "_hz-4";
export var lightActionButton = "_hz-1";
export var link = "_hz-b";
export var merchant = "_hz-5";
export var message = "_hz-c";
export var profilePicture = "_hz-e";
export var quillToolbarContainer = "_hz-f";
export var senderDate = "_hz-g";
export var senderDateCustomer = "_hz-h";
export var senderName = "_hz-d";
export var time = "_hz-k";
export var uploadedImage = "_hz-l";
export var username = "_hz-m";
export var xsmall = "_hz-n";